import get from 'ts-get';

import core from '@gin-betting/core';

const {
    utils: { getBettingOptions },
} = core;

function checkIfNewsPage() {
    return get(
        getBettingOptions(),
        bettingOptions => bettingOptions.url.pagePath,
        ''
    ).includes('/news');
}

export default checkIfNewsPage;
